import { TPhotoCardResponse } from '@verifime/components';
import { format, isValid } from 'date-fns';

const YYYY_MM_DD = /^\d{4}-\d{2}-\d{2}$/;

/**
 * The photo card expiry as person-api reads it (yyyy-MM-dd), or undefined when the card carries
 * none. Two photo card templates print no expiry, so an absent expiry is normal here and must not
 * reach `format`, which throws on an invalid date.
 *
 * A date the form already holds as yyyy-MM-dd is passed through: new Date('2030-01-31') is
 * midnight UTC, which formats as the day before in a time zone behind UTC.
 */
function formatExpiry(expiry: unknown): string | undefined {
  if (!expiry) {
    return undefined;
  }
  if (typeof expiry === 'string' && YYYY_MM_DD.test(expiry)) {
    return expiry;
  }
  const date = new Date(expiry as string | Date);
  return isValid(date) ? format(date, 'yyyy-MM-dd') : undefined;
}

/**
 * Builds the `photoCard` object the wizard submits. A field the customer left empty (the middle
 * name, the expiry) is left out rather than sent as a blank, and the form data it is given is not
 * changed.
 */
export function toPhotoCardPayload(photoCard: Partial<TPhotoCardResponse>): TPhotoCardResponse {
  const payload: Record<string, unknown> = {};
  for (const [field, value] of Object.entries(photoCard ?? {})) {
    if (value !== undefined && value !== null && value !== '') {
      payload[field] = value;
    }
  }

  const expiry = formatExpiry(payload.photoCardExpiry);
  if (expiry) {
    payload.photoCardExpiry = expiry;
  } else {
    delete payload.photoCardExpiry;
  }
  return payload as TPhotoCardResponse;
}
